import { render, staticRenderFns } from "./EmployerGroupGeneralInfo.vue?vue&type=template&id=f22f39e6&"
import script from "./EmployerGroupGeneralInfo.vue?vue&type=script&lang=js&"
export * from "./EmployerGroupGeneralInfo.vue?vue&type=script&lang=js&"
import style0 from "./EmployerGroupGeneralInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports